import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {NodeOutputData, NodeType} from 'common/src/modules/nodes/nodes.types';
import {DistributionCardScratchpadState} from '../../scratchpad/distributionCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const addDistributionOutputInputSchema = z.object({
  name: z.string().describe('The name of the output'),
});

export default function addDistributionOutputTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof addDistributionOutputInputSchema,
      DistributionCardScratchpadState
    >,
  ) {
    const {name} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<DistributionCardScratchpadState>(
      agentScratchpad,
      NodeType.DISTRIBUTION,
    );

    const nextId =
      validatedScratchpad.card.outputs.length > 0
        ? Math.max(...validatedScratchpad.card.outputs.map((o) => o.id), 0) + 1
        : 1;

    const newOutput: NodeOutputData = {
      id: nextId,
      nodeId: NO_NODE_ID,
      name: name ?? `Output ${nextId}`,
    };

    validatedScratchpad.card.outputs.push(newOutput);

    return toolResult(`Distribution output "${name}" added successfully`);
  }

  return tool<typeof addDistributionOutputInputSchema, DistributionCardScratchpadState>({
    name: V2CardAgentToolName.AddDistributionOutput,
    displayName: 'Adding distribution output',
    description: 'Add a new output to the distribution card.',
    inputSchema: addDistributionOutputInputSchema,
    execute,
  });
}
